module.exports = __webpack_public_path__ + "img/avatar-ceramic.517ffeb7.jpg";